import React from 'react';
import {StyledAlertMessageCard} from "./ProductDetail.styled";
import {Flex} from "antd";

const Alert = () => {
    return (
        <StyledAlertMessageCard>

            
            <div style={{
                display: "flex",
                gap: "8px",
                alignItems: "flex-start",
                backgroundColor: "#fff5f5",
                border: "1px solid #ffcccc",
                borderRadius: "8px",
                padding: "12px"
            }}>
                <div style={{ fontSize: "24px" }}>🚨</div>
                <div style={{ flex: 1, textAlign: "right", lineHeight: 1.6 }}>
                    <div>پلتفرم «پیدا» صرفاً بستر ارتباط میان کاربران است و هیچ‌گونه مسئولیتی در قبال صحت اطلاعات آگهی‌ها یا معاملات ندارد.</div>
                    <div> پیش از پرداخت هرگونه وجه، از اصالت کالا و هویت آگهی‌دهنده اطمینان حاصل کنید.</div>
                    <div>
                         برای اطلاعات بیشتر 
                        <a href="/conditions" target="_self" rel="noopener noreferrer" style={{ color: "#1677ff", textDecoration: "none" }}>شرایط استفاده از خدمات</a> و 
                        <a href="/terms" target="_self" rel="noopener noreferrer" style={{ color: "#1677ff", textDecoration: "none" }}>حریم خصوصی</a> پلتفرم «پیدا» را مطالعه فرمایید.
                    </div>
                </div>
 
            </div>

        </StyledAlertMessageCard>
    );
};

export default Alert;
